import React, { useEffect, useState } from 'react';
import axios from 'axios';

function AddNewPerformance({ cogen_id }) {
    const [formData, setFormData] = useState({
        season: '',
        bgas_production: '',
        buy_bgas: '',
        other_fuel: '',
        electricity_export: '',
        working_days: '',
        total_ecity_prod: '',
        factory_usage: '',
        cogen_usage: '',
        total_ecity_export: '',
        ecity_export_perhr: ''
    });

    const [existingSeasons, setExistingSeasons] = useState([]); // ✅ store existing seasons
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        const fetchExistingData = async () => {
            try {
                const res = await axios.get(`https://backend-zkgn.onrender.com/api/performance/cogen/${cogen_id}`);
                if (Array.isArray(res.data)) {
                    const seasons = res.data.map(item => item.season?.toLowerCase());
                    setExistingSeasons(seasons);
                }
            } catch (err) {
                console.error('Error fetching existing performance data:', err);
            }
        };
        fetchExistingData();
    }, [cogen_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        const tempErrors = {};
        let isValid = true;

        Object.entries(formData).forEach(([key, value]) => {
            if (!value.trim()) {
                tempErrors[key] = `${key.replace(/_/g, ' ')} is required.`;
                isValid = false;
            } else if ((key !== 'season') && isNaN(value)) {
                tempErrors[key] = `Enter numeric value for ${key.replace(/_/g, ' ')}.`;
                isValid = false;
            }
        });

        // ✅ Check duplicate season before submit
        if (existingSeasons.includes(formData.season.toLowerCase())) {
            tempErrors.season = `Performance data for season "${formData.season}" already exists.`;
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await axios.post('https://backend-zkgn.onrender.com/api/performance', {
                ...formData,
                cogen_id
            });

            setSuccessMessage('Performance data added successfully!');
            setFormData({
                season: '',
                bgas_production: '',
                buy_bgas: '',
                other_fuel: '',
                electricity_export: '',
                working_days: '',
                total_ecity_prod: '',
                factory_usage: '',
                cogen_usage: '',
                total_ecity_export: '',
                ecity_export_perhr: ''
            });

            setTimeout(() => setSuccessMessage(''), 3000);
        } catch (error) {
            console.error('Error adding performance data', error);
        }
    };

    return (
        <div className="container my-5">
            <h4 className="mb-4 text-center">Add New Performance Data</h4>

            {successMessage && (
                <div className="alert alert-success text-center" role="alert">
                    {successMessage}
                </div>
            )}

            <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Season</label>
                        <input
                            type="text"
                            className="form-control"
                            name="season"
                            value={formData.season}
                            onChange={handleChange}
                        />
                        {errors.season && <small className="text-danger">{errors.season}</small>}
                    </div>

                    {[
                        ['bgas_production', 'Bagasse Production (MT)'],
                        ['buy_bgas', 'Purchased Bagasse (MT)'],
                        ['other_fuel', 'Other Fuel (MT)'],
                        ['electricity_export', 'Electricity Export (MW)'],
                        ['working_days', 'Working Days'],
                        ['total_ecity_prod', 'Total Electricity Produced (MW)'],
                        ['factory_usage', 'Factory Usage (MW)'],
                        ['cogen_usage', 'Cogeneration Usage (MW)'],
                        ['total_ecity_export', 'Total Electricity Export (MW)'],
                        ['ecity_export_perhr', 'Electricity Export Per Hour (MW)'],
                    ].map(([key, label]) => (
                        <div className="col-md-6" key={key}>
                            <label className="form-label">{label}</label>
                            <input
                                type="text"
                                className="form-control"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                            />
                            {errors[key] && <small className="text-danger">{errors[key]}</small>}
                        </div>
                    ))}
                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-success px-4">
                        Submit Performance Data
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddNewPerformance;
